<template lang="pug">
  .notification-list.js-notification-list
    .notification-list__item(v-for="(item, key) in notification" v-if="item.read" :ref="'data-'+key")
      .notification(:class="item.notification_type | classNotification")
        .notification__icon
          img(src="@/assets/images/icons/notification-success.svg" v-if="item.notification_type === 1")
          img(src="@/assets/images/icons/notification-pending.svg" v-if="item.notification_type === 2")
          img(src="@/assets/images/icons/notification-error.svg" v-if="item.notification_type === 3")
        .notification__text {{item.text}}
        button.notification__button-close(@click="onHide(key)")
          img(src="@/assets/images/icons/notification-close.svg")


</template>

<script>
export default {
  name: "operator-notification",
  props: ["notification"],
  methods: {
    onHide(key) {
      this.$refs["data-" + key][0].style.display = "none";
    },
  },
};
</script>
http://localhost:8080/img/notification-close.2cf73270.svg
